import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import type { ManufacturerDraft } from './ManufacturerList.types'

export interface ManufacturerModalProps {
  open: boolean
  onClose: () => void
  onSave: (draft: ManufacturerDraft) => void
}

export function ManufacturerModal({ open, onClose, onSave }: ManufacturerModalProps) {
  const [draft, setDraft] = useState<ManufacturerDraft>({
    provider: '',
    alias: '',
    mfrCodeUpper: '',
    url: '',
    direct: false,
  })

  useEffect(() => {
    if (!open) return
    setDraft({ provider: '', alias: '', mfrCodeUpper: '', url: '', direct: false })
  }, [open])

  const canSave = draft.provider.trim().length > 0

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Manufacturer</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            label="Manufacturer"
            value={draft.provider}
            onChange={e => setDraft((p: ManufacturerDraft) => ({ ...p, provider: e.target.value }))}
            fullWidth
          />
          <TextField
            label="Alias"
            value={draft.alias}
            onChange={e => setDraft((p: ManufacturerDraft) => ({ ...p, alias: e.target.value }))}
            fullWidth
          />
          <TextField
            label="OEM Code"
            value={draft.mfrCodeUpper}
            onChange={e => setDraft((p: ManufacturerDraft) => ({ ...p, mfrCodeUpper: e.target.value }))}
            fullWidth
          />
          <TextField
            label="URL"
            value={draft.url}
            onChange={e => setDraft((p: ManufacturerDraft) => ({ ...p, url: e.target.value }))}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={!canSave} onClick={() => onSave(draft)}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  )
}
